import { Loader2, AlertTriangle, Beer } from "lucide-react";
import { useSearch } from "@/context/SearchContext";

export function ResultsState({ empty }) {
  const { status, error, venues, origin } = useSearch();
  if (status === "locating") return <Note icon={Loader2} spin text="Finding your location…" />;
  if (status === "error" && !venues.length) return <Note icon={AlertTriangle} text={error || "Our AI venue finder is busy right now. Please try again in a few minutes."} testId="search-error" />;
  if (status === "loading" && !venues.length)
    return <Note icon={Loader2} spin text={`Our AI is scouting happy hours around ${origin?.city || "you"}… this takes about a minute the first time.`} testId="search-loading" />;
  if (status === "error" && venues.length)
    return <Note icon={AlertTriangle} text="Our AI venue finder is busy, so you're seeing owner-submitted spots only. Search again in a few minutes for more." testId="search-partial" />;
  if (status === "idle") return <Note icon={Beer} text="Use your location or pick a city to see happy hours near you." testId="search-idle" />;
  if (empty && status !== "error") return <Note icon={Beer} text="No happy hours match these filters. Try another day or clear a filter." testId="search-empty" />;
  return null;
}

function Note({ icon: Icon, text, spin, testId }) {
  return (
    <div data-testid={testId} className="panel flex items-center gap-4 p-6 text-zinc-300">
      <Icon className={`shrink-0 text-[#fde68a] ${spin ? "animate-spin" : ""}`} size={22} />
      <p>{text}</p>
    </div>
  );
}
